module.exports = __webpack_public_path__ + "static/img/bgimg.0fc8e037.png";